export default "__VITE_ASSET__DEiYOKB8__"